import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20971 20953"
    {...props}
  >
    <defs>
      <style>
        {
          //   ".str0{stroke:#000;stroke-width:303.925;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528318423040">
        <path
          d="M1106 558h18730"
          className="fill-none stroke1"
          style={{
            strokeWidth: 303.925,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
        <circle
          cx={20412}
          cy={558}
          r={406}
          className="fill-none stroke1"
          style={{
            strokeWidth: 303.925,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M965 558c0 225-182 407-407 407-224 0-406-182-406-407 0-224 182-406 406-406 225 0 407 182 407 406zM8818 1964c-289-49-569-103-703-12-284 192-304 238-608 238s-304-238-607-238-303 238-606 238-303-238-607-238c-303 0-303 238-606 238-302 0-302-238-605-238s-303 238-606 238c-302 0-302-238-604-238-303 0-338 586-737 217-233-215-416-279-546-234-80 28-135 160-135 306v18437M8723 20801l90-18792M4289 1903V681M6282 2075V681M8275 1764V558M2268 1952V558"
          className="fill-none stroke1"
          style={{
            strokeWidth: 303.925,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M1848 20677c228 43 459 124 624 124 313 0 313-246 625-246s312 246 625 246c312 0 312-246 624-246s312 246 624 246 312-246 624-246c313 0 313 246 626 246 312 0 312-246 625-246 312 0 312 246 625 246 314 0 314-246 627-246s313 246 626 246M5330 20368v-9013M3582 20555v-5167M7023 20368v-6640M19487 1966c-301-49-594-107-737-14-298 192-319 238-638 238-318 0-318-238-637-238-318 0-318 238-635 238-318 0-318-238-637-238-317 0-317 238-635 238-317 0-317-238-635-238s-318 238-635 238-317-238-634-238c-318 0-354 586-773 217-244-215-437-279-573-234-84 28-142 160-142 306v18437M19388 20801l94-18792M14737 1903V681M16827 2075V681M18917 1801V681M12617 1952V558M12176 20678c253 10 451 123 656 123 327 0 327-246 655-246 327 0 327 246 655 246 327 0 327-246 655-246 327 0 327 246 654 246 328 0 328-246 655-246 328 0 328 246 656 246s328-246 656-246 328 246 656 246 328-246 657-246c328 0 328 246 657 246M15829 20368v-9013M13995 20555v-5167M17605 20368v-6640"
          className="fill-none stroke1"
          style={{
            strokeWidth: 303.925,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
